import React from 'react';
import { Section } from './Shared';
export function About() {
  return <div className="bg-sage-light/20 border-y border-beige-muted/50" data-id="element-40">
      <Section data-id="element-41">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-42">
          {/* Left — Logo */}
          <div className="flex justify-center" data-id="element-43">
            <div className="bg-white rounded-2xl shadow-sm border border-beige-muted/30 p-10 md:p-14" data-id="element-44">
              <img src="https://cdn.magicpatterns.com/uploads/eUwhbvivvB42pJGq8CDtmv/WhatsApp_Image_2026-03-16_at_11.35.09_(1).jpg" alt="Maternalab Logo" className="w-48 md:w-64 h-auto object-contain" data-id="element-45" />
            </div>
          </div>

          {/* Right — Text */}
          <div data-id="element-46">
            <span className="text-sm font-bold text-sage-dark uppercase tracking-wider" data-id="element-47">
              ¿Quiénes somos?
            </span>

            <h2 className="font-playfair text-2xl md:text-4xl text-charcoal leading-tight mt-3 mb-6" data-id="element-48">
              Maternalab nació para acompañar a las mamás que nadie acompaña a
              las 3 de la mañana
            </h2>

            <div className="space-y-5 text-charcoal-light text-lg leading-relaxed" data-id="element-49">
              <p data-id="element-50">
                Somos un equipo de mamás y especialistas en desarrollo infantil
                que saben lo que es estar agotadas, haber probado de todo y no
                encontrar respuestas claras.
              </p>
              <p data-id="element-51">
                Por eso creamos el{' '}
                <strong className="text-charcoal" data-id="element-52">
                  Método Dormir sin Lágrimas
                </strong>
                : una guía práctica, respetuosa y aplicable en la vida real, no
                en condiciones de laboratorio.
              </p>
              <p className="font-medium text-charcoal" data-id="element-53">
                Más de 1.000 familias ya lo aplicaron. Y seguimos acá,
                mejorándolo.
              </p>
            </div>

            {/* Badge */}
            <div className="flex flex-wrap gap-3 mt-8" data-id="element-54">
              <span className="bg-white border border-beige-muted/50 text-charcoal text-sm font-medium px-4 py-2 rounded-full shadow-sm" data-id="element-55">
                ⭐ +1.000 mamás acompañadas
              </span>
              <span className="bg-white border border-beige-muted/50 text-charcoal text-sm font-medium px-4 py-2 rounded-full shadow-sm" data-id="element-56">
                🤱 Enfoque respetuoso
              </span>
              <span className="bg-white border border-beige-muted/50 text-charcoal text-sm font-medium px-4 py-2 rounded-full shadow-sm" data-id="element-57">
                📋 Método probado
              </span>
            </div>
          </div>
        </div>
      </Section>
    </div>;
}